import i18n from '@/i18n/i18n';

const state = {
  currentLanguage: localStorage.getItem('userLanguage') || 'pt',
  hasSelectedLanguage: !!localStorage.getItem('userLanguage')
};

const mutations = {
  SET_LANGUAGE(state, language) {
    state.currentLanguage = language;
    state.hasSelectedLanguage = true;
  }
};

const actions = {
  initializeLanguage({ commit }) {
    const savedLanguage = localStorage.getItem('userLanguage');
    if (savedLanguage) {
      commit('SET_LANGUAGE', savedLanguage);
      i18n.global.locale.value = savedLanguage;
    }
    return !!savedLanguage;
  },
  
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
    i18n.global.locale.value = language;
    return true;
  }
};

const getters = {
  hasSelectedLanguage: (state) => state.hasSelectedLanguage,
  currentLanguage: (state) => state.currentLanguage
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
